import { render, staticRenderFns } from "./Wages.vue?vue&type=template&id=2db5a28a&"
import script from "./Wages.vue?vue&type=script&lang=js&"
export * from "./Wages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports